import { useTranslation } from "react-i18next";
import Drug from "../drug/Drug";
import SwitchView from "./SwitchView";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import React, { useContext, useEffect, useState } from "react";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import { Consts } from "../pages/consts";
import DrugsTable from "./DrugsTable";
import {hospitalLanguages} from "../../resources/json/jsons";

const TabularView = ({
  selectedPatient,
  patDrugs,
  onDeleteDrug,
  setDrugsView,
  viewName,
  label,
  hcpView,
  errorParent,
  loadingParent,
  onReceiveAndHandlePrescriptions
}) => {
  const { t: t } = useTranslation();
  const context = useContext(InitContext);
  const [addDrug, setAddDrug] = useState(false);
  const [allProductNames, setAllProductNames] = useState([]); // drug ProductNames prepared for select elements with value and label keys
  const [allSubstances, setAllSubstances] = useState([]); // drug active Substances prepared for select elements with value and label keys

  const {
    loading,
    error,
    clearError,
    getDrugProductsJson,
    getDrugSubstancesJson,
    saveDbDrug
  } = useMmcService();

  const language = hospitalLanguages[!selectedPatient ? context?.patient?.study_id : selectedPatient?.study_id];

  useEffect(() => {
    clearError();

    getDrugProductsJson(context?.token, language) // "product" and "substance" - searching kinds
      .then((data) => setAllProductNames(data));
  }, []);

  useEffect(() => {
    clearError();

    getDrugSubstancesJson(context?.token, language) // "product" and "substance" - searching kinds
      .then((data) => setAllSubstances(data));
  }, []);

  const handleAddDrug = () => {
    setAddDrug(true);
  };

  const saveDrug = (drug) => {
    clearError();
    setAddDrug(false);

    const patientId = !selectedPatient
      ? context?.patient?.id
      : selectedPatient?.id;

    saveDbDrug(context?.token, drug, patientId)
      .then(() => {
        onReceiveAndHandlePrescriptions().then();
        // setAddDrug(false);
      });
  };

  let message =
    errorParent && errorParent?.includes(Consts.DELETE)
      ? t("error_by_deleting_a_drug")
      : t("error_by_retrieving_prescribed_drugs");

  message =
    error && error?.includes(Consts.INTERACTION)
      ? t("error_by_retrieving_drug_drug_interactions")
      : message;

  const errorMessage = (error || errorParent) && (
    <ErrorMessage message={message} />
  );

  const spinner = (loading || loadingParent) && <Spinner />;

  return (
    <>
      {addDrug && (
        <Drug
          onSaveDrug={saveDrug}
          onHandleAddDrug={setAddDrug}
          allProductNames={allProductNames}
          allSubstances={allSubstances}
          patDrugs={patDrugs}
          language={language}
        />
      )}
      {hcpView ? (
        <>
          {errorMessage}
          {spinner}
          {patDrugs?.length > 1 && (
            <div className="w3-container w3-padding w3-right">
              <SwitchView
                setDrugsView={setDrugsView}
                viewName={viewName}
                label={label}
              />
            </div>
          )}
          <DrugsTable
            patDrugs={patDrugs}
            onDeleteDrug={onDeleteDrug}
            onAddDrug={handleAddDrug}
            loading={loading || loadingParent}
          />
        </>
      ) : (
        <div className="w3-display-container content-container">
          <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
            <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
          </div>
          <div className="w3-display-middle w3-center form-display">
            <div className="w3-panel w3-card-4 record-panel">
              <header className="w3-container w3-center">
                <div className="w3-display-container w3-padding-small">
                  <h2>
                    {context?.role === Consts.PATIENT
                      ? t("your_medication_pat")
                      : t("your_medication")}
                  </h2>
                  {patDrugs?.length > 1 && (
                    <div className="w3-display-right">
                      <SwitchView
                        setDrugsView={setDrugsView}
                        viewName={viewName}
                        label={label}
                      />
                    </div>
                  )}
                </div>
              </header>
              <div className="w3-row-padding">
                <label className="disclaimer-text w3-padding-small">
                  {t("drug_disclaimer")} {t("drug_disclaimer_2")}{" "}
                  {t("drug_disclaimer_3")}
                </label>
              </div>
              {errorMessage}
              {spinner}
              <DrugsTable
                patDrugs={patDrugs}
                onDeleteDrug={onDeleteDrug}
                onAddDrug={handleAddDrug}
                loading={loading || loadingParent}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TabularView;
